import { service } from '../../../../helpers/http'

export const ActionGetArpRecords = (_, payload) => {
    return service({
        module: 'domainArpRecords',
        action: 'getArpRecords',
        payload: payload
    })
}

export const ActionGetArpRecord = (_, payload) => {
    return service({
        module: 'domainArpRecords',
        action: 'getArpRecord',
        payload: payload
    })
}

export const ActionGetArpRecordTypes = (_, payload) => {
    return service({
        module: 'domainArpRecords',
        action: 'getArpRecordTypes',
        payload: payload
    })
}

export const ActionGetArpResponsibleTypes = (_, payload) => {
    return service({
        module: 'domainArpRecords',
        action: 'getArpResponsibleTypes',
        payload: payload
    })
}

export const ActionGetArpEstablishments = (_, payload) => {
    return service({
        module: 'domainArpRecords',
        action: 'getArpEstablishments',
        payload: payload
    })
}

export const ActionGetArpStats = (_, payload) => {
    return service({
        module: 'domainArpRecords',
        action: 'getArpStats',
        payload: payload
    })
}

export const ActionVerifyArpRecord = (_, payload) => {
    return service({
        module: 'domainArpRecords',
        action: 'verifyArpRecord',
        payload: payload
    })
}

export const ActionVerifyArpChain = (_, payload) => {
    return service({
        module: 'domainArpRecords',
        action: 'verifyArpChain',
        payload: payload
    })
}
